var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 352,
    viewBox: "0 0 352 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 352,
    fill: "#1EAFD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227 144C242.464 144 255 131.688 255 116.5C255 101.312 242.464 89 227 89C211.536 89 199 101.312 199 116.5C199 131.688 211.536 144 227 144Z",
    stroke: "white",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 204C138.136 204 150 192.136 150 177.5C150 162.864 138.136 151 123.5 151C108.864 151 97 162.864 97 177.5C97 192.136 108.864 204 123.5 204Z",
    stroke: "white",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5 264C241.136 264 253 252.136 253 237.5C253 222.864 241.136 211 226.5 211C211.864 211 200 222.864 200 237.5C200 252.136 211.864 264 226.5 264Z",
    stroke: "white",
    strokeWidth: 7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202 130L146 164",
    stroke: "white",
    strokeWidth: 7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203 225L148.39 189",
    stroke: "white",
    strokeWidth: 7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d6708399a80ac785b6a89ea509c7e2fd.svg";
export { ForwardRef as ReactComponent };